export const KIOSK_ACCESSOR_ERRORS_MESSAGES = {
    notLogged: 'Please enter your phone number before inserting bills.',
    productNotSelected: 'Please select a product before inserting bills.',
    closeGameFirst: 'Please close popup before inserting bills.',
};
